import * as React from "react";
import styled from "styled-components";
import {
    ConstBreakPoint,
    ConstColor,
    ConstHeight,
    ConstWidth,
    ConstZIndex
} from "../../../config/styles_const/styles_const";

interface IProps {
    canAnimation: boolean;
    // canAnimationがtrueのときに必須
    isVisibleForFadeout?: boolean;
}

const Progress: React.FC<IProps> = (props) => {
    const isVisible: boolean = props.canAnimation
        ? (props.isVisibleForFadeout ? props.isVisibleForFadeout : true)
        : true;

    return(

        <OverlayWrapper isVisible={isVisible}>
            <Indicator/>
        </OverlayWrapper>
    )
};

export default Progress;

const OverlayWrapper = styled.div<{isVisible: boolean}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${ConstZIndex.progress};
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 1s, visibility 1s;
    // background-color: rgba(255, 255, 255, 0.93);
    background: ${ConstColor.White};
    opacity: ${props => props.isVisible ? 1 : 0};
    visibility: ${props => props.isVisible ? "visible" : "hidden"};
    @media (min-width: ${ConstBreakPoint.PcDeskTop}) {
        padding-left: ${ConstWidth.MenuWidth};
        padding-top: ${ConstHeight.HeaderHeight};
    }
`;

const Indicator = styled.div`
    width: 30px; /*ローディングアイコンの横サイズ*/
    height: 30px; /*ローディングアイコンの縦サイズ*/
    border-radius: 50%; /*CSS3で円を書く*/
    border: 4px solid ${ConstColor.Corporate}; /*円に○の枠をつける*/
    border-right-color: transparent; /*円の右にC状の空きをつける*/
    animation: spin 1s linear infinite; /*1秒毎にくるくる回転するアニメーション*/
    @keyframes spin {
        /*0%の時は20％の透明度*/
        0% {
            transform: rotate(0deg);
            opacity: 0.2;
        }
    
        /*50%の時は透明度なし*/
        50% {
            transform: rotate(180deg);
            opacity: 1.0;
        }
    
        /*100%の時に20％の透明度に戻る*/
        100% {
            transform: rotate(360deg);
            opacity: 0.2;
        }
    
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/progress.tsx